import { sortAlphaByList } from '../utils'
import { createSelector } from 'reselect'

const selectorFactory = (groupedAssetsSelector) =>
  createSelector(groupedAssetsSelector, (assets) =>
    Object.fromEntries(
      Object.entries(assets.crypto).sort(([, a], [, b]) =>
        sortAlphaByList(a.name, b.name, ['bitcoin', 'ethereum'])
      )
    )
  )

const cryptoAssetsSelectorDefinition = {
  id: 'cryptoAssets',
  selectorFactory,
  dependencies: [{ selector: 'groupedAssets' }],
}

export default cryptoAssetsSelectorDefinition
